import { render, staticRenderFns } from "./AlertOffersContent.vue?vue&type=template&id=2de8ebbc"
import script from "./AlertOffersContent.vue?vue&type=script&lang=js"
export * from "./AlertOffersContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports